const reduceObject = (obj, fn) => Object.entries(obj).reduce((acc, [key, value]) => fn(acc, value, key), Object.assign({}, obj));
export default reduceObject;